import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import MdChevronRight from 'react-icons/lib/md/chevron-right';
import MdExpandMore from 'react-icons/lib/md/expand-more';

import { formatNumber, formatLargeNumber } from '../../../service/market';

import table from '../../../styles/table/flextable';
import css from '../../../styles/instrument/brokers/broker';

class Brokers extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        expanded: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        MEMBER_NAME: PropTypes.string,
        BROKER_ID: PropTypes.string.isRequired,
        BROKER_CHANGE: PropTypes.number,
        TRADES_COUNT: PropTypes.number,
        TRADES_COUNT_BUYS: PropTypes.number,
        TRADES_COUNT_SELLS: PropTypes.number,
        TRADES_PRICE_AVERAGE_BUYS: PropTypes.number,
        TRADES_PRICE_AVERAGE_SELLS: PropTypes.number,
        TRADES_TURNOVER: PropTypes.number,
        TRADES_TURNOVER_BUYS: PropTypes.number,
        TRADES_TURNOVER_SELLS: PropTypes.number,
    }

    constructor(props) {
        super(props);

        this._getSign = n => {
            if (!n || n === 0) {
                return table.neutral;
            }

            return n > 0 ? table.positive : table.negative;
        };
    }

    renderExpanded() {
        const {
            t,
            expanded, TRADES_PRICE_AVERAGE_BUYS, TRADES_PRICE_AVERAGE_SELLS, TRADES_TURNOVER,
            TRADES_TURNOVER_BUYS, TRADES_TURNOVER_SELLS, TRADES_COUNT_BUYS, TRADES_COUNT_SELLS,
        } = this.props;

        if (!expanded) {
            return null;
        }

        const buyShare = (TRADES_TURNOVER_BUYS / TRADES_TURNOVER) * 100;
        const sellShare = (TRADES_TURNOVER_SELLS / TRADES_TURNOVER) * 100;

        return (
            <div className={css.container}>
                <div className={css.bar}>
                    <div className={css.positiveBar} style={{ width: `${buyShare}%` }} />
                </div>
                <div className={css.flexJustify}>
                    <div>
                        <div className={css.title}>{t('brokerage.buyTurnover')}</div>
                        <div className={css.item}>
                            <span className={css.emphasize}>
                                {formatLargeNumber(TRADES_TURNOVER_BUYS)}
                            </span> ({formatNumber(buyShare, 1)}%)
                        </div>
                        <div className={css.item}>
                            <span>{t('brokerage.averagePrice')}: <span className={css.emphasize}>
                                {formatNumber(TRADES_PRICE_AVERAGE_BUYS)}
                            </span></span>
                        </div>
                        <div className={css.item}>
                            <span>{t('brokerage.trades')}: <span className={css.emphasize}>
                                {formatNumber(TRADES_COUNT_BUYS, 0)}
                            </span></span>
                        </div>
                    </div>
                    <div className={css.listRight}>
                        <div className={css.title}>{t('brokerage.salesTurnover')}</div>
                        <div className={css.item}>
                            <span className={css.emphasize}>
                                {formatLargeNumber(TRADES_TURNOVER_SELLS)}
                            </span> ({formatNumber(sellShare, 1)}%)
                        </div>
                        <div className={css.item}>
                            <span>{t('brokerage.averagePrice')}: <span className={css.emphasize}>
                                {formatNumber(TRADES_PRICE_AVERAGE_SELLS)}
                            </span></span>
                        </div>
                        <div className={css.item}>
                            <span>{t('brokerage.trades')}: <span className={css.emphasize}>
                                {formatNumber(TRADES_COUNT_SELLS, 0)}
                            </span></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            expanded, onClick, MEMBER_NAME, BROKER_CHANGE,
            TRADES_TURNOVER, BROKER_ID,
        } = this.props;

        return (
            <div className={table.tableRow} onClick={() => onClick(BROKER_ID)}>
                <div className={`${table.tableCell} ${table.ellipsis}`}>
                    <span className={css.chevron}>
                        {expanded ? <MdExpandMore /> : <MdChevronRight />}
                    </span>
                    {MEMBER_NAME}
                </div>
                <div className={table.tableCell}>
                    {formatLargeNumber(TRADES_TURNOVER, 1)}
                </div>
                <div className={[table.tableCell, table.change].join(' ')}>
                    <span className={this._getSign(BROKER_CHANGE)}>
                        {formatLargeNumber(BROKER_CHANGE, 2)}%
                    </span>
                </div>
                {this.renderExpanded()}
            </div>
        );
    }
}

export default translate('stocks')(Brokers);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/brokers/Broker.js
 **/